/*
  TODO: Create matching Shopify Automatic Discounts or a Shopify Function for
  each tier discount below. This widget shows the intended bundle discount and
  adds the correct variants/properties, but /cart/add.js cannot change Shopify
  line prices by itself.
*/
(function () {
  "use strict";

  if (customElements.get("bundle-offer")) return;

  function formatMoney(cents, format) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    var comma = amount.replace(".", ",");
    var value = amount;

    if (format && format.indexOf("amount_no_decimals_with_comma_separator") !== -1) value = noDecimals;
    else if (format && format.indexOf("amount_with_comma_separator") !== -1) value = comma;
    else if (format && format.indexOf("amount_no_decimals") !== -1) value = noDecimals;

    return format
      ? format
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, value)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, value)
          .replace(/\{\{\s*amount\s*\}\}/, value)
      : "$" + amount;
  }

  function closestProductRoot(el) {
    return (
      el.closest(".m-main-product") ||
      el.closest("[data-product-id]") ||
      document.querySelector(".m-main-product") ||
      document
    );
  }

  class BundleOffer extends HTMLElement {
    connectedCallback() {
      if (this.booted) return;
      this.booted = true;

      var config = this.querySelector("[data-bundle-offer-config]");
      if (!config) return;

      try {
        this.config = JSON.parse(config.textContent);
      } catch (error) {
        return;
      }

      this.variants = this._uniqueSizeVariants(this.config.variants || []);
      this.onlyAvailableSize = this.variants.filter(function (variant) {
        return variant.available;
      }).length === 1;
      this.selectedTier = (this.config.tiers || []).filter(function (tier) {
        return tier.isDefault;
      })[0] || (this.config.tiers || [])[0];
      if (!this.selectedTier || !this.variants.length) return;

      this.slotsEl = this.querySelector("[data-bundle-slots]");
      this.addButton = this.querySelector("[data-bundle-add]");
      this.error = this.querySelector("[data-bundle-error]");
      this.subtotalEl = this.querySelector("[data-bundle-subtotal]");
      this.discountEl = this.querySelector("[data-bundle-discount]");
      this.totalEl = this.querySelector("[data-bundle-total]");
      this.barTotalEl = this.querySelector("[data-bundle-bar-total]");
      this.shipping = this.querySelector("[data-bundle-shipping]");
      this.shippingMessage = this.querySelector("[data-bundle-shipping-message]");
      this.shippingValue = this.querySelector("[data-bundle-shipping-value]");
      this.shippingTrack = this.querySelector(".bundle-offer__track");
      this.shippingFill = this.querySelector("[data-bundle-shipping-fill]");
      this.giftQty = this.querySelector("[data-bundle-gift-qty]");
      this.priorityInput = this.querySelector("[data-bundle-priority]");
      this.priorityRow = this.querySelector("[data-bundle-priority-row]");
      this.priorityTotalEl = this.querySelector("[data-bundle-priority-total]");
      this.slots = [];
      this.submitting = false;

      this._moveBelowBuyButton();
      this._activateBundleOnlyLayout();
      this._disableInvisibleGalleryClicks();
      this._keepBelowBuyButton();
      this._bindTierRadios();
      this._bindAdd();
      this._bindPriority();
      this._setSlotCount(Math.max(1, Number(this.selectedTier.quantity) || 1));
      this._renderSlots();
      this._update();
    }

    getVariantInput() {
      var root = closestProductRoot(this);
      return root.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    }

    getCurrentVariantSize() {
      var input = this.getVariantInput();
      var id = input && input.value ? Number(input.value) : null;
      var match = this.variants.filter(function (variant) {
        return Number(variant.id) === id;
      })[0];
      return match ? match.size : "";
    }

    _uniqueSizeVariants(variants) {
      var seen = {};
      return variants.reduce(function (list, variant) {
        if (!variant.size || seen[variant.size]) return list;
        seen[variant.size] = true;
        list.push(variant);
        return list;
      }, []);
    }

    _moveBelowBuyButton() {
      var root = closestProductRoot(this);
      var buyButtons = root.querySelector(".main-product__block-buy_buttons");
      var pill = root.querySelector(".fq-pill");
      var target = pill || buyButtons;
      if (pill) {
        pill.classList.add("fq-pill--bundle-below");
        pill.classList.add("fq-pill--bundle-only");
      }
      if (!target || target.contains(this)) return;

      if (pill) {
        pill.appendChild(this);
      } else {
        target.parentNode.insertBefore(this, target.nextSibling);
      }
    }

    _activateBundleOnlyLayout() {
      var root = closestProductRoot(this);
      if (root && root.classList) root.classList.add("fq-product--bundle-only");
    }

    _keepBelowBuyButton() {
      var self = this;
      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        self._moveBelowBuyButton();
        self._disableInvisibleGalleryClicks();
        if (self.closest(".fq-pill") || tries > 30) window.clearInterval(timer);
      }, 150);
    }

    _disableInvisibleGalleryClicks() {
      document.querySelectorAll(".m-media-gallery__inner, [class*='swiper-container']").forEach(function (el) {
        var style = window.getComputedStyle(el);
        if (Number(style.opacity) === 0) {
          el.style.pointerEvents = "none";
        }
      });
    }

    _bindTierRadios() {
      var self = this;
      this.querySelectorAll("[data-bundle-tier-radio]").forEach(function (radio) {
        var card = radio.closest(".bundle-offer__tier");
        if (card) {
          card.addEventListener("click", function () {
            if (radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          });
        }

        radio.addEventListener("change", function () {
          if (!radio.checked) return;
          var tier = self._findTier(radio.value);
          if (!tier) return;
          self.selectedTier = tier;
          self.querySelectorAll(".bundle-offer__tier").forEach(function (card) {
            card.classList.toggle("is-selected", card.contains(radio));
          });
          self._setSlotCount(Math.max(1, Number(tier.quantity) || 1));
          self._renderSlots();
          self._update();
        });
      });
    }

    _bindAdd() {
      var self = this;
      if (!this.addButton) return;
      this.addButton.addEventListener("click", function () {
        self._addBundle();
      });
    }

    _bindPriority() {
      var self = this;
      if (!this.priorityInput) return;
      var priorityCard = this.priorityInput.closest(".bundle-offer__priority");

      if (priorityCard) {
        priorityCard.addEventListener("click", function (event) {
          if (event.target === self.priorityInput) return;
          event.preventDefault();
          self.priorityInput.checked = !self.priorityInput.checked;
          self.priorityInput.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      this.priorityInput.addEventListener("change", function () {
        self._update();
      });
    }

    _findTier(id) {
      return (this.config.tiers || []).filter(function (tier) {
        return String(tier.id) === String(id);
      })[0];
    }

    _setSlotCount(count) {
      var currentSize = this.getCurrentVariantSize();
      while (this.slots.length < count) {
        this.slots.push({
          size: this.slots.length === 0 ? currentSize : this.onlyAvailableSize ? this._firstAvailableSize() : "",
          name: ""
        });
      }
      if (this.slots.length > count) this.slots = this.slots.slice(0, count);
    }

    _firstAvailableSize() {
      var match = this.variants.filter(function (variant) {
        return variant.available;
      })[0];
      return match ? match.size : "";
    }

    _renderSlots() {
      if (!this.slotsEl) return;
      var self = this;
      var single = this.slots.length === 1;
      this.slotsEl.innerHTML = "";

      this.slots.forEach(function (slot, index) {
        var row = document.createElement("div");
        var nameId = "bundle-name-" + self.dataset.sectionId + "-" + index;
        var sizeId = "bundle-size-" + self.dataset.sectionId + "-" + index;
        row.className = "bundle-offer__slot";
        row.dataset.bundleSlot = String(index);

        row.innerHTML =
          '<div class="bundle-offer__slot-title"><span class="bundle-offer__slot-number"' +
          (single ? ' hidden' : "") +
          ">" +
          (index + 1) +
          '.</span><strong>' + ((self.dataset.itemNoun || 'blanket').charAt(0).toUpperCase() + (self.dataset.itemNoun || 'blanket').slice(1)) + ' ' +
          (index + 1) +
          "</strong></div>" +
          '<label class="bundle-offer__sr-only" for="' +
          sizeId +
          '">Size for ' + (self.dataset.itemNoun || 'blanket') + ' ' +
          (index + 1) +
          "</label>" +
          '<label class="bundle-offer__field"><span>Size</span><select id="' +
          sizeId +
          '" class="bundle-offer__control" data-bundle-size>' +
          self._sizeOptions(slot.size, index) +
          "</select></label>" +
          '<label class="bundle-offer__sr-only" for="' +
          nameId +
          '">Optional personalized name for ' + (self.dataset.itemNoun || 'blanket') + ' ' +
          (index + 1) +
          "</label>" +
          '<label class="bundle-offer__field bundle-offer__field--name"><span><span>Name <small>optional</small></span><b class="bundle-offer__free-badge">FREE</b></span><span class="bundle-offer__name-field"><input id="' +
          nameId +
          '" class="bundle-offer__control" type="text" maxlength="12" data-bundle-name autocomplete="off" placeholder="Personalized name (optional)" value="' +
          self._escape(slot.name) +
          '"><span data-bundle-count>' +
          String(slot.name || "").length +
          "/12</span></span></label>" +
          '<strong class="bundle-offer__slot-price" data-bundle-slot-price>-</strong>';

        row.querySelector("[data-bundle-size]").addEventListener("change", function (event) {
          self.slots[index].size = event.target.value;
          self._update();
        });

        row.querySelector("[data-bundle-name]").addEventListener("input", function (event) {
          self.slots[index].name = event.target.value;
          var count = row.querySelector("[data-bundle-count]");
          if (count) count.textContent = event.target.value.length + "/12";
          self._update();
        });

        self.slotsEl.appendChild(row);
      });
    }

    _sizeOptions(selectedSize, index) {
      var options = ['<option value="">' + (index === 0 ? "Choose a size" : "Choose a size") + "</option>"];
      this.variants.forEach(function (variant) {
        var selected = selectedSize === variant.size ? " selected" : "";
        var disabled = variant.available ? "" : " disabled";
        options.push(
          '<option value="' +
            String(variant.size).replace(/"/g, "&quot;") +
            '"' +
            selected +
            disabled +
            ">" +
            variant.size +
            " - " +
            formatMoney(variant.priceCents, "") +
            (variant.available ? "" : " Sold out") +
            "</option>"
        );
      });
      return options.join("");
    }

    _escape(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    _variantForSize(size) {
      return this.variants.filter(function (variant) {
        return variant.size === size;
      })[0];
    }

    _priorityAddon() {
      var config = this.config.priority || {};
      var enabled = config.enabled !== false && this.priorityInput && this.priorityInput.checked;
      var priceCents = Math.max(0, Number(config.priceCents) || 0);
      if (!enabled || !priceCents) return null;
      return {
        label: config.label || "Priority Processing + VIP Membership",
        description: config.description || "Jump the queue and unlock VIP perks",
        priceCents: priceCents,
        variantId: config.variantId ? Number(config.variantId) : null
      };
    }

    computeBundleTotal() {
      var missingSizeIndex = this.slots.findIndex(function (slot) {
        return !slot.size;
      });

      if (missingSizeIndex !== -1) {
        return { subtotal: null, discount: null, total: null, ready: false, message: "Select a size for " + (this.dataset.itemNoun || 'blanket') + " " + (missingSizeIndex + 1) + "." };
      }

      var blanketSubtotal = this.slots.reduce(
        function (sum, slot) {
          var variant = this._variantForSize(slot.size);
          return sum + (variant ? Number(variant.priceCents) || 0 : 0);
        }.bind(this),
        0
      );

      var priorityAddon = this._priorityAddon();
      var priorityTotal = priorityAddon ? priorityAddon.priceCents : 0;
      var subtotal = blanketSubtotal + priorityTotal;
      var discount = 0;
      var value = Number(this.selectedTier.discountValue) || 0;
      if (this.selectedTier.discountType === "percentage") discount = Math.round(blanketSubtotal * (value / 100));
      if (this.selectedTier.discountType === "fixed_amount") discount = Math.round(value * 100);
      discount = Math.min(discount, blanketSubtotal);

      return {
        subtotal: subtotal,
        blanketSubtotal: blanketSubtotal,
        priorityTotal: priorityTotal,
        priorityAddon: priorityAddon,
        discount: discount,
        total: subtotal,
        checkoutTotal: Math.max(subtotal - discount, 0),
        hasCheckoutDiscount: discount > 0,
        ready: true,
        message: ""
      };
    }

    _update() {
      var summary = this.computeBundleTotal();
      this._updateSlotPrices();
      this._updateTotals(summary);
      this._updateShipping(summary);
      this._updateGift();
      this._updatePriorityState(summary);
      if (this.addButton) this.addButton.disabled = !summary.ready || this.submitting;
      if (summary.ready) this._clearError();
      else this._showError(summary.message);
    }

    _updatePriorityState(summary) {
      if (!this.priorityInput) return;
      var priorityCard = this.priorityInput.closest(".bundle-offer__priority");
      if (priorityCard) priorityCard.classList.toggle("is-selected", Boolean(summary.priorityAddon));
    }

    _updateSlotPrices() {
      var self = this;
      this.querySelectorAll("[data-bundle-slot]").forEach(function (row) {
        var index = Number(row.dataset.bundleSlot);
        var price = row.querySelector("[data-bundle-slot-price]");
        var variant = self._variantForSize(self.slots[index] && self.slots[index].size);
        if (price) price.textContent = variant ? formatMoney(variant.priceCents, self.config.moneyFormat) : "-";
      });
    }

    _updateTotals(summary) {
      var discountText = "-";
      if (summary.ready) {
        if (this.selectedTier.discountType === "percentage" && Number(this.selectedTier.discountValue) > 0) {
          discountText = this.selectedTier.discountValue + "% if store discount is active";
        } else if (this.selectedTier.discountType === "fixed_amount" && Number(this.selectedTier.discountValue) > 0) {
          discountText = formatMoney(summary.discount, this.config.moneyFormat) + " if store discount is active";
        } else {
          discountText = formatMoney(0, this.config.moneyFormat);
        }
      }

      if (this.subtotalEl) this.subtotalEl.textContent = summary.ready ? formatMoney(summary.subtotal, this.config.moneyFormat) : "-";
      if (this.priorityRow) this.priorityRow.hidden = !summary.ready || !summary.priorityTotal;
      if (this.priorityTotalEl) this.priorityTotalEl.textContent = summary.ready ? formatMoney(summary.priorityTotal || 0, this.config.moneyFormat) : "-";
      if (this.discountEl) this.discountEl.textContent = discountText;
      if (this.totalEl) this.totalEl.textContent = summary.ready ? formatMoney(summary.total, this.config.moneyFormat) : "-";
      if (this.barTotalEl) this.barTotalEl.textContent = summary.ready ? formatMoney(summary.total, this.config.moneyFormat) : "-";
    }

    _updateShipping(summary) {
      var threshold = Number(this.config.freeShippingThresholdCents) || 9900;
      var total = summary.ready ? summary.total : 0;
      var unlocked = summary.ready && total >= threshold;
      var progress = threshold > 0 ? Math.max(0, Math.min(100, (total / threshold) * 100)) : 100;

      if (this.shipping) this.shipping.classList.toggle("bundle-offer__shipping--unlocked", unlocked);
      if (this.shippingMessage) {
        this.shippingMessage.textContent = unlocked
          ? "You've unlocked free shipping"
          : "Add " + formatMoney(Math.max(threshold - total, 0), this.config.moneyFormat) + " more to get free shipping";
      }
      if (this.shippingValue) this.shippingValue.textContent = summary.ready ? formatMoney(total, this.config.moneyFormat) : "-";
      if (this.shippingFill) this.shippingFill.style.width = progress + "%";
      if (this.shippingTrack) this.shippingTrack.setAttribute("aria-valuenow", String(Math.round(progress)));
    }

    _updateGift() {
      if (!this.giftQty) return;
      var count = Math.max(1, this.slots.length);
      this.giftQty.textContent = count + " matching pillow" + (count > 1 ? "s" : "") + " included";
    }

    _addBundle() {
      var summary = this.computeBundleTotal();
      if (!summary.ready) {
        this._update();
        return;
      }

      var bundleGroup = [
        "bundle",
        Date.now(),
        Math.random().toString(36).slice(2, 8)
      ].join("-");

      var self = this;
      var priorityAddon = summary.priorityAddon;
      var items = this.slots.map(function (slot, index) {
        var variant = self._variantForSize(slot.size);
        var properties = {
          _bundle_group: bundleGroup,
          _bundle_role: "blanket",
          _bundle_position: String(index + 1),
          _bundle_discount_type: self.selectedTier.discountType,
          _bundle_discount_value: String(self.selectedTier.discountValue || 0)
        };
        if (slot.name && slot.name.trim()) properties["Personalized Name"] = slot.name.trim();
        if (index === 0 && priorityAddon) {
          properties["Priority Processing + VIP Membership"] = priorityAddon.variantId
            ? "Added"
            : "Selected (+$" + (priorityAddon.priceCents / 100).toFixed(2) + ")";
        }
        return {
          id: variant.id,
          quantity: 1,
          properties: properties
        };
      });

      if (this.config.gift && this.config.gift.variantId) {
        items.push({
          id: this.config.gift.variantId,
          quantity: this.slots.length,
          properties: {
            _free_gift: "Free matching pillow with quilt",
            _bundle_role: "free_pillow",
            _bundle_group: bundleGroup
          }
        });
      }

      if (priorityAddon && priorityAddon.variantId) {
        items.push({
          id: priorityAddon.variantId,
          quantity: 1,
          properties: {
            _bundle_role: "priority_processing",
            _bundle_group: bundleGroup,
            _priority_processing_vip: "true"
          }
        });
      }

      this.submitting = true;
      this._clearError();
      this.addButton.disabled = true;
      this.addButton.classList.add("is-loading");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw data;
            return data;
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
          window.location.href = "/cart";
        })
        .catch(
          function () {
            this._showError("Something went wrong adding your bundle. Please try again.");
          }.bind(this)
        )
        .finally(
          function () {
            this.submitting = false;
            this.addButton.classList.remove("is-loading");
            this._update();
          }.bind(this)
        );
    }

    _showError(message) {
      if (!this.error) return;
      this.error.hidden = false;
      this.error.textContent = message || "";
    }

    _clearError() {
      if (!this.error) return;
      this.error.hidden = true;
      this.error.textContent = "";
    }
  }

  customElements.define("bundle-offer", BundleOffer);
})();
